import { inject, Injectable } from '@angular/core';
import {
  ExpertWorkspaceExpertRole,
  ExpertWorkspaceRecord,
} from '@libs/shared/api';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { NavigationService } from '@sprint-expert/app/core/navigation/navigation.service';
import { Navigation } from '@sprint-expert/app/core/navigation/navigation.types';

import { pipe, switchMap } from 'rxjs';

interface NavigationCoreState {
  content: Navigation;
  isLoading: boolean;
  isLoaded: boolean;
  errorMessage: string;
}

const initialState: NavigationCoreState = {
  content: undefined,
  isLoading: false,
  isLoaded: false,
  errorMessage: '',
};

@Injectable({
  providedIn: 'root',
})
export class NavigationCoreStore {
  readonly #navigationService = inject(NavigationService);

  readonly state = signalState(initialState);
  readonly content$$ = this.state.content;
  readonly isLoading$$ = this.state.isLoading;
  readonly isLoaded$$ = this.state.isLoaded;
  readonly errorMessage$$ = this.state.errorMessage;

  constructor() {}

  fetchNavigation = rxMethod<{
    expertWorkspace: ExpertWorkspaceRecord;
    workspaceExpertRole: ExpertWorkspaceExpertRole;
  }>(
    pipe(
      switchMap(payload =>
        this.#navigationService
          .getByWorkspaceUserRole(
            payload.expertWorkspace,
            payload.workspaceExpertRole
          )
          .pipe(
            tapResponse(
              (navigation: Navigation) => {
                patchState(this.state, {
                  content: navigation,
                  isLoading: false,
                  isLoaded: true,
                  errorMessage: '',
                });
              },
              () => {
                patchState(this.state, {
                  content: undefined,
                  isLoading: false,
                  isLoaded: false,
                  errorMessage: "Couldn't fetch navigation",
                });
              }
            )
          )
      )
    )
  );
}
